import { createAction } from '@reduxjs/toolkit';

import { CHANGE_CURRENT_PLAN_PERIOD } from 'redux/plans/plans.types';

export const changeCurrentPeriod = createAction(CHANGE_CURRENT_PLAN_PERIOD, (payload) => ({ payload }));
